import React, { lazy, Suspense } from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';
import Loading from '~/components/Loading';
import { EmailFeatureFlags, FeatureFlags } from '~/zustand/featureFlag/useFeatureFlagStore';

const SignIn = lazy(() => import('~/pages/SignIn'));
const Oauth = lazy(() => import('~/pages/SignIn/oauth'));
const SignOut = lazy(() => import('~/pages/SignOut'));
const DashboardHome = lazy(() => import('~/pages/Dashboard'));
const RealPhotosHome = lazy(() => import('~/pages/RealPhotos'));
const RealPhotosDetailsPage = lazy(() => import('~/pages/RealPhotos/RealPhotosDetailsPage'));
const RealPhotosFaqPage = lazy(() => import('~/pages/RealPhotos/RealPhotosFaqPage'));

function Routes() {
  return (
    <Suspense fallback={<Loading loading />}>
      <Switch>
        <Route path="/login" exact component={SignIn} />
        <Route path="/oauth" component={Oauth} />
        <Route path="/" tabName="Dashboard" exact component={DashboardHome} isPrivate />
        <Route path="/signout" component={SignOut} isPrivate />
        <Route
          path="/real-photos/faq"
          component={RealPhotosFaqPage}
          isPrivate
          noLayout
          requiresFeatureFlag={FeatureFlags.RealPhotos}
          requiresEmailFeatureFlag={EmailFeatureFlags.RealPhotos}
        />
        <Route
          path="/real-photos/details/:gfpLineId"
          component={RealPhotosDetailsPage}
          isPrivate
          noLayout
          requiresFeatureFlag={FeatureFlags.RealPhotos}
          requiresEmailFeatureFlag={EmailFeatureFlags.RealPhotos}
        />
        <Route
          path="/real-photos"
          component={RealPhotosHome}
          isPrivate
          noLayout
          requiresFeatureFlag={FeatureFlags.RealPhotos}
          requiresEmailFeatureFlag={EmailFeatureFlags.RealPhotos}
        />
      </Switch>
    </Suspense>
  );
}

export default Routes;
